/**
 * The two readings of a press, as a control three knobs share.
 *
 * A choice rather than a toggle control, for the reason `hudSkin.ts` states: "toggle: off" would
 * name one reading as the absence of the other, and holding a key is not the neutral state of
 * anything. Both are ways to work a control and the player is picking one.
 *
 * Shared rather than written out three times because the options are the same options. What
 * differs between aim, crouch and sprint is the label, the hint and which verb the value reaches,
 * and each of those lives in the knob file that owns it. A row of buttons repeated per knob would
 * be one list of options in three places, and a fourth latchable verb would have to find all three.
 */

import { SETTING_HOLD_MODE_HOLD, SETTING_HOLD_MODE_TOGGLE } from '@/text/settingsText';
import type { ChoiceControl } from '@/ui/settings/settingContract';

export const HOLD_MODE_CHOICE: ChoiceControl = {
  kind: 'choice',
  options: [
    // Held first, because it is the default and the order the buttons sit in is the order a
    // player reads them: the thing the game already does, then the thing they can change it to.
    { value: 'hold', label: SETTING_HOLD_MODE_HOLD },
    { value: 'toggle', label: SETTING_HOLD_MODE_TOGGLE },
  ],
};
